// Decode JWT payload from base64url-encoded token

/**
 * decodeJwt: decodes JWT payload for form prefill; returns null if malformed
 *
 * @param {string} token JWT token (three dot-separated segments)
 * @return {object|null} Decoded payload object, or null on any decode error
 */
export const decodeJwt = (token) => {
  try {
    const payload = token.split('.')[1]
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}
